<footer class="footer" >
    <div class="container">

        <!-- CA970783 - Cambio Logo
            <img style="height: 10vh;" src="assets/icons/logo_superSalud.svg" alt="img" alt="img">
            <br>
            &#169; Copyright {{ anioActual }} | Todos los derechos reservados.
            <br>
            v: 1.0.0.2
        -->

        <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
            <img style="height: 20vh;" src="assets/icons/logo_superSalud_2025.svg" alt="img">
        </div>

       <!--  <br>
        <a href="https://www.facebook.com/saludtotaleps/" tabindex="-1" target="_blank">
            <img style="height: 3vh; padding: 0.5%;" src="assets/icons/logo_Facebook.svg" alt="img" alt="img">
        </a>
        <a href="https://www.instagram.com/saludtotalpac/" tabindex="-1" target="_blank">
            <img style="height: 3vh; padding: 0.5%;" src="assets/icons/logo_Instagram.svg" alt="img" alt="img">
        </a>
        <a href="https://www.youtube.com/user/saludtotaleps" tabindex="-1" target="_blank">
            <img style="height: 3vh; padding: 0.5%;" src="assets/icons/logo_Youtube.svg" alt="img" alt="img">
        </a> -->
    </div>
</footer>